import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { GenericInput } from '../../common';
import ModalSearchItem from '../../common/ModalSearchItem';
import ModalSearchPriceOffer from '../../common/ModalSearchPriceOffer';

const searchInputs = [
  {
    label: 'label.startDate',
    name: 'startDate',
    type: 'date',
  },
  {
    label: 'label.endDate',
    name: 'endDate',
    type: 'date',
  },
  {
    label: 'label.priceOfferName',
    name: 'priceOfferName',
    fa: 'fa fa-external-link',
  },
  {
    label: 'label.accountType',
    name: 'accountType',
    type: 'select',
    tOptions: 'selections:accountType',
    isClearable: true,
  },
  {
    label: 'label.itemName',
    name: 'itemName',
    fa: 'fa fa-external-link',
  },
  {
    label: 'label.serviceType',
    name: 'serviceType',
    type: 'select',
    tOptions: 'selections:serviceType',
    isClearable: true,
  },
  {
    label: 'label.status',
    name: 'status',
    tOptions: 'selections:invoiceStatus',
    isClearable: true,
    type: 'select',
  },
  {
    label: 'label.billUnitStatus',
    name: 'billUnitStatus',
    tOptions: 'selections:billStatus',
    isClearable: true,
    type: 'select',
  },
  {
    label: 'label.transactionType',
    name: 'transactionType',
    type: 'select',
    tOptions: 'selections:transactionType',
    isClearable: true,
  },
  {
    label: 'label.transactionDescription',
    name: 'transactionDescription',
  },
  {
    label: 'label.billableServiceName',
    name: 'billableServiceName',
  },
  {
    label: 'label.productFamily',
    name: 'productFamily',
    type: 'select',
    options: [],
    isClearable: true,
  },
  {
    label: 'label.organization',
    name: 'company',
  },
];

class TransactionSummarySearchForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalName: '',
      productFamilyOptions: [],
    };
  }

  componentDidMount() {
    this.setDefaultInputs();
    const { getUniqueProductFamily } = this.props;
    getUniqueProductFamily('', ({ data, success }) => {
      if (success && data) {
        const productFamilyOptions = data.map(val => {
          return { label: val.productFamily, value: val.productFamily };
        });
        this.setState({ productFamilyOptions });
      }
    });
  }

  setDefaultInputs = () => {
    searchInputs.map(input => this.setState({ [input.name]: null }));
  };

  handleInputChange = ({ name, value }) => {
    this.setState({ [name]: value });
  };

  handleSubmit = e => {
    e.preventDefault();
    e.stopPropagation();
    const { onSubmit } = this.props;
    const data = {};
    searchInputs.map(input => (this.state[input.name] ? (data[input.name] = this.state[input.name]) : null));
    if (onSubmit) {
      onSubmit(data);
    }
  };

  handleReset = e => {
    e.preventDefault();
    e.stopPropagation();
    this.setDefaultInputs();
  };

  onSelect = (value, row) => {
    const { modalName } = this.state;
    this.setState({ [modalName]: row.name, modalName: '' });
  };

  onOpenModal = ({ modalName }) => {
    this.setState({ modalName });
  };

  onToggleModal = () => {
    this.setState({ modalName: '' });
  };

  render() {
    const { isSubmitting, t } = this.props;
    const { modalName, productFamilyOptions } = this.state;
    return (
      <form onSubmit={this.handleSubmit}>
        <div className="form-row">
          {searchInputs.map(item => {
            if (item.name === 'productFamily') {
              return (
                <GenericInput
                  key={item.name}
                  {...item}
                  label={t && t(item.label) ? t(item.label) : item.label}
                  value={this.state[item.name]}
                  onChange={this.handleInputChange}
                  options={productFamilyOptions || []}
                />
              );
            }
            return (
              <GenericInput
                key={item.name}
                {...item}
                label={t && t(item.label) ? t(item.label) : item.label}
                value={this.state[item.name]}
                isNeedClearable
                onChange={this.handleInputChange}
                onClick={item.fa ? () => this.onOpenModal({ modalName: item.name }) : () => {}}
              />
            );
          })}
          <div className="form-group text-right btn-search-actions col-md-9">
            <label htmlFor="validationCustom01se" />
            <br />
            <button
              type="button"
              className="button button-border black x-small"
              disabled={isSubmitting}
              onClick={this.handleReset}
            >
              {t('label.clear')}
            </button>
            <button type="submit" className="button x-small" disabled={isSubmitting}>
              {t('label.search')}
            </button>
          </div>
        </div>
        <ModalSearchItem
          isOpen={modalName === 'itemName'}
          onSelect={this.onSelect}
          onCancel={this.onToggleModal}
          selectedParentId={this.state && this.state.itemName ? this.state.itemName : ''}
        />
        <ModalSearchPriceOffer
          isOpen={modalName === 'priceOfferName'}
          onSelect={this.onSelect}
          onCancel={this.onToggleModal}
          selectedParentId={this.state && this.state.priceOfferName ? this.state.priceOfferName : ''}
        />
      </form>
    );
  }
}

TransactionSummarySearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

TransactionSummarySearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(TransactionSummarySearchForm);
